import { createConsumer, type Consumer } from '@rails/actioncable'
import { CableEvent, type Message } from './protocol'

// LF-918: one Action Cable connection per page, opened only once a coach asks
// their first question.

let consumer: Consumer | null = null

export type StreamHandlers = {
  onMessage: (message: Message) => void
  onConnected: () => void
  onDisconnected: () => void
  onRejected: () => void
}

export const subscribeToConversation = (
  streamToken: string,
  handlers: StreamHandlers,
): (() => void) => {
  consumer ??= createConsumer()
  const subscription = consumer.subscriptions.create(
    { channel: 'ChatbotConversationChannel', token: streamToken },
    {
      received(data: unknown) {
        const parsed = CableEvent.safeParse(data)
        if (parsed.success) handlers.onMessage(parsed.data.message)
        else console.error('Unexpected chatbot broadcast', parsed.error)
      },
      connected: handlers.onConnected,
      disconnected: handlers.onDisconnected,
      rejected: handlers.onRejected,
    },
  )
  return () => subscription.unsubscribe()
}
